import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { GqlClientType } from "~/__generated__";
import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import ClientForm, { ClientFormInput } from "../../components/ClientForm";
import useClientCreate from "./api/useClientCreate";

const initialData: ClientFormInput = {
    name: "",
    type: GqlClientType.Private,
    address: "",
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    website: null,
    profilePicture: null,
    isAllMapEditorLayersDefaultVisible: false,
};

export default function ClientCreateScreen() {
    const { t } = useTranslation("client");
    const navigate = useNavigate();

    const { clientCreate, error } = useClientCreate();

    const handleSubmit = async (data: ClientFormInput) => {
        const result = await clientCreate({
            ...data,
            contactEmail: data.contactEmail || null,
            website: data.website ?? null,
            profilePicture: data.profilePicture ?? null,
        });
        if (result.data?.clientCreate) {
            navigate(-1);
        }
    };

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("clientCreateScreen.title")}>
                <ClientForm
                    initialData={initialData}
                    onSubmit={handleSubmit}
                    error={error}
                    formButtonLabel={t("clientCreateScreen.btnSubmit")}
                />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
